import React from 'react';
import { Box, type SxProps } from '@mui/material';
import { CopyIconButton } from '../CopyIconButton/CopyIconButton';

export type CopyFieldProps = {
    value: React.ReactNode;
    copyValue?: string;
    sx?: SxProps;
    alwaysShowCopy?: boolean;
};

export const CopyField: React.FunctionComponent<CopyFieldProps> = function ({
    value,
    copyValue,
    sx,
    alwaysShowCopy = false,
}) {
    const rawValue = copyValue ?? (typeof value === 'string' ? value : null);
    const canCopy = Boolean(rawValue);

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '2px',
                ...(!alwaysShowCopy &&
                    canCopy && {
                        '&:hover .copy-icon-btn, .copy-icon-btn[data-copied="true"]': {
                            opacity: '1 !important',
                            transform: 'translateX(0) !important',
                            pointerEvents: 'auto !important',
                        },
                    }),
                ...sx,
            }}
        >
            {value}
            {canCopy && (
                <CopyIconButton
                    copyValue={rawValue!}
                    size={24}
                    iconSize="11px"
                    className="copy-icon-btn"
                    sx={
                        alwaysShowCopy
                            ? {}
                            : {
                                  opacity: 0,
                                  transform: 'translateX(-4px)',
                                  pointerEvents: 'none',
                                  transition: 'opacity 0.2s ease, transform 0.2s ease',
                              }
                    }
                />
            )}
        </Box>
    );
};
